<div
  [ngClass]="{
    'toast': true,
    'toast-success': type() === ToastType.SUCCESS,
    'toast-info': type() === ToastType.INFO,
    'toast-warning': type() === ToastType.WARNING,
    'toast-error': type() === ToastType.ERROR,
  }"
>
  <div class="content-box">
    <div class="content-box-wrapper">
      <div class="content-box-layout">
        <div class="title-box">
          @if (icon()) {
            <ion-icon class="title-icon" [name]="icon()" />
          }

          <div class="titles">
            <div class="titles-layout">
              <div class="main-title">{{ title() }}</div>
              @if (subtitle()) {
                <div class="subtitle">
                  {{ subtitle() }}
                </div>
              }
            </div>
          </div>
        </div>

        <ion-button class="close-button" type="button" (click)="handleClose()">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </div>
    </div>
  </div>

  @if (buttons().length > 0) {
    <div class="button-box">
      @for (button of buttons(); track button.text) {
        <ion-button fill="clear" size="small" (click)="handleClick(button)">
          {{ button.text }}
          <ion-icon class="button-icon" name="arrow-forward-outline" />
        </ion-button>
      }
    </div>
  }
</div>
